var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('html',[_c('head'),_c('body',[_c('h2',[_vm._v("游戏服列表")]),_c('p',[_vm._v("有些游戏需要游戏服用于对战（例如射手）。这里可以配置多个游戏服用于版本测试、停服维护等功能。")])])])])
}]

export { render, staticRenderFns }